export default {
  PASSENGER_REQUEST: 'PASSENGER_REQUEST',
  PASSENGER_SUCCESS: 'PASSENGER_SUCCESS',
  PASSENGER_FAILURE: 'PASSENGER_FAILURE',
  SAVE_PASSENGER_REQUEST: 'SAVE_PASSENGER_REQUEST',
  SAVE_PASSENGER_SUCCESS: 'SAVE_PASSENGER_SUCCESS',
  SAVE_PASSENGER_FAILURE: 'SAVE_PASSENGER_FAILURE',
};



// WEBPACK FOOTER //
// ./src/redux/constants/PassengerConstants.js